import { render, staticRenderFns } from "./textview.vue?vue&type=template&id=3a7b482c&"
import script from "./textview.vue?vue&type=script&lang=ts&"
export * from "./textview.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports